import { createLogger } from "./logger.js";
const log = createLogger({ component: "shutdown" });
export function installShutdownHandlers(controller, handlers) {
    let shuttingDown = false;
    const run = async (signal) => {
        if (shuttingDown)
            return;
        shuttingDown = true;
        log.info("shutdown signal received", { signal }); // phi-ok: OS signal name, not a health signal
        controller.abort();
        for (const handler of handlers) {
            try {
                await handler();
            }
            catch (err) {
                log.error("shutdown handler failed", { error: String(err) });
            }
        }
        process.exit(0);
    };
    process.on("SIGTERM", () => void run("SIGTERM"));
    process.on("SIGINT", () => void run("SIGINT"));
}
/**
 * Stop accepting new connections and wait for in-flight requests to drain,
 * force-closing whatever remains after `timeoutMs` so shutdown never hangs
 * on a stuck keep-alive connection. Register this as the FIRST shutdown
 * handler so requests drain before stores and pools close underneath them.
 */
export function closeHttpServer(server, timeoutMs = 10_000) {
    return new Promise((resolve) => {
        let settled = false;
        const finish = () => {
            if (settled)
                return;
            settled = true;
            resolve();
        };
        const timer = setTimeout(() => {
            server.closeAllConnections?.();
            finish();
        }, timeoutMs);
        timer.unref();
        server.closeIdleConnections?.();
        server.close(() => {
            clearTimeout(timer);
            finish();
        });
    });
}
//# sourceMappingURL=shutdown.js.map